import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'; // 导入element-ui包
import 'element-ui/lib/theme-chalk/index.css'; // 导入相关样式

import router from './router'
Vue.use(ElementUI); // 引用
//弹窗时，页面滚动条抖动
ElementUI.Dialog.props.lockScroll.default = false;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
